<template
  ><v-card class="p-4">
    <v-card-title>
      Nos partenaires
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Rechercher sur les noms"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>

      <export-btn entity="partners"/>

      <!-- bouton trash à partir de 2 checkbox de cocher -->
      <v-btn v-if="selected.length >= 2" class="mx-2" fab dark small color="red" data-toggle="tooltip" title="Suppression des partenaires sélectionnés" >
        <v-icon dark v-model="selected" small @click="deletePartners(selected[0].partner)">
          mdi-delete
        </v-icon>
      </v-btn>

      <router-link :to="{ name: 'creerPartenaire' }">
        <v-btn class="mx-2" fab dark small color="indigo" data-toggle="tooltip" title="Création d'un partenaire">
          <v-icon dark>
            mdi-plus
          </v-icon>
        </v-btn>
      </router-link>

    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="partners"
      :search="search"
      :items-per-page="12"
      :page.sync="pagination.currentPage"
      @page-count="pageCountChange"
      hide-default-footer
      v-model="selected"
      :single-select="singleSelect"
      show-select
    >
      <template #item.url="{ item }">
        <a target="_blank" :href="item.url">{{item.url}}</a>
      </template>
      <template v-slot:item.logo="{ item }">
        <v-icon v-if="item.logo" small color="green">mdi-checkbox-marked-circle</v-icon>
        <v-icon v-if="!item.logo" small color="red">mdi-checkbox-blank-circle</v-icon>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <router-link :to="{ name: 'modifierPartenaire', params: { id: item.id, partner: item }}">
          <v-icon small class="mr-2">
            mdi-pencil
          </v-icon>
          </router-link>

          <v-icon small @click="deletePartner(item)">
            mdi-delete
          </v-icon>
      </template>
    </v-data-table>

    <v-pagination
      v-model="pagination.currentPage"
      :length="pagination.pagesNumber"
      class="pt-5"
    ></v-pagination>
  </v-card>
</template>

<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>

import Api from "@/core/services/api.service";
import Swal from "sweetalert2";
import ExportBtn from "@/components/admin/exportBtn";

export default {
  name: "partners",
  components: { ExportBtn },
  data() {
    return {
      confirmDelete: false,
      loading: true,
      options: {},
      search: "",
      headers: [
        { text: "Nom", value: "name", align: "start" },
        { text: "URL", value: "url", align: "start" },
        { text: "Logo", value: "logo", sortable: false, align: "center" },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],
      pagination: {
        currentPage: 1,
        pagesNumber: 0,
      },
      deletedIndex: -1,
      singleSelect: false,
      selected: [], // Liste des partneraires sélectionnés dans le tableau
      partners: [],
    };
  },

  watch: {
    search(value) {
      this.search = value;
      this.pagination.currentPage = 1;
      //this.getAllPartners();
    },
    options: {
      handler() {
        //this.getAllPartners();
      },
      deep: true
    }
  },
  methods: {
    getAllPartners() {
      this.loading = true;
      Api.get("partners?pagination=false").then((partners) => {
        this.partners = partners.data["hydra:member"];
        this.loading = false;
      });
    },
    deletePartner(item) {
      Swal.fire({
        title: "Voulez-vous vraiment supprimer ce partnaire ?",
        text: "Attention, cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletedIndex = this.partners.indexOf(item);
          Api.delete("partners/" + item.id).then(() => {
            this.partners.splice(this.deletedIndex, 1),
            Swal.fire(
              "Supprimé !",
              "Votre partenaire a été supprimée",
              "success"
            ),
            this.getAllPartners();
          });
        }
      })
    },
    deletePartners() {
      Swal.fire({
        title: "Voulez-vous vraiment supprimer ce partenaire ?",
        text: "Attention, cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
      })
      .then((result) => {
        if (result.isConfirmed) {
          const selectedItems = this.selected
          for(var i=0; i < selectedItems.length; i++){
            Api.delete("partners/" + selectedItems[i].id).then(() => {
              Swal.fire(
                "Supprimé !",
                "Votre partenaire a été supprimé",
                "success"
              )
              this.getAllPartners();
            });
          }
        }
      });
    },

    pageCountChange(pageCount) {
      this.pagination.pagesNumber = pageCount;
    },
  },
  mounted() {
    this.getAllPartners();
  }
}
</script>
